import React from 'react';
import { BaseMediaObject, MediaSourceType, ObjectFit } from './types';
import { MediaRole } from '../MediaRole';
import {
    SerializableState,
    TextMediaState,
    Serializable
} from '../types/serializable';
import { validateMediaState } from '../schemas/timeline-schema';

export interface TextMedia extends BaseMediaObject {
    type: 'text';
    text: string;
    content: Record<string, unknown>;
}

export class TextMediaImpl implements TextMedia, Serializable {
    id: string;
    type: 'text' = 'text';
    role: MediaRole;
    text: string;
    content: Record<string, unknown>;

    constructor(id: string, role: MediaRole, text: string) {
        this.id = id;
        this.role = role;
        this.text = text;
        this.content = { text };
    }

    /**
     * Export TextMedia to serializable state
     */
    exportState(): TextMediaState {
        const state: TextMediaState = {
            type: 'TextMedia',
            version: '1.0.0',
            id: this.id,
            text: this.text,
            content: this.content
        };

        // Add optional properties
        if (this.role !== undefined) state.role = this.role;

        return state;
    }

    /**
     * Import TextMedia from serialized state
     */
    static importState(state: SerializableState): TextMediaImpl {
        const validatedState = validateMediaState(state);
        if (validatedState.type !== 'TextMedia') {
            throw new Error(`Expected TextMedia state, received ${validatedState.type}`);
        }

        const inst = new TextMediaImpl(
            validatedState.id,
            (validatedState.role as MediaRole) || 'main',
            validatedState.text
        );

        // Preserve serialized content (fallback to {text} if missing)
        inst.content = validatedState.content ?? { text: validatedState.text };

        return inst;
    }

    render(fps: number, blockId: string, duration: number, objectFit?: ObjectFit, videoConfig?: { width: number; height: number }): React.ReactNode {
        // Text media rendering handled by caption components
        return null;
    }
}
